import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Spin, Input, Tooltip } from 'antd';
import * as Styled from './style.js';
import { getData } from '../../config/api-connect';
import dayjs from 'dayjs';
import { FaAngleDoubleLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import {FilterFilled} from '@ant-design/icons';
import {capitalizeFirstLetter} from '../../utils/stringUtil.js'

const ApplicantList = () => {
  const { jobId } = useParams();
  const [applicants, setApplicants] = useState(null);
  const [loading, setLoading] = useState(true);
  const [jobTitle, setJobTitle] = useState(null);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (jobId) {
      getData(`/career/get_job_applications/?job_id=${jobId}`)
        .then((res) => {
          setApplicants(res.result);
          setJobTitle(res.title)
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching job details:", error);
          setLoading(false);
        });
    }
  }, [jobId]);

  const normalizeLocation = (str = '') => str.toString().trim().toLowerCase();

  const getLocationFilter = (dataIndex) => {
    const uniqueValues = [...new Set(applicants.map(item => normalizeLocation(item[dataIndex])).filter(Boolean))];

    return {
      filters: [
        ...uniqueValues.map(v => ({
          text: capitalizeFirstLetter(v),
          value: v,
        })),
        { text: 'Show Empty Only', value: '__EMPTY__' }
      ],

      onFilter: (value, record) => {
        const recordValue = normalizeLocation(record[dataIndex]);

        if (value === '__EMPTY__') {
          return !recordValue;
        }

        if (['trivandrum', 'thiruvananthapuram'].includes(value)) {
          return ['trivandrum', 'thiruvananthapuram'].includes(recordValue);
        }

        return recordValue === value;
      },

      filterIcon: filtered => (
        <FilterFilled style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };


  if (loading) return <Spin style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }} />;
  if (!applicants) return <div>No job found.</div>;

  const filteredApplicants = applicants.filter((a) => {
	  const search = searchText.toLowerCase();
	  return (
	    a.applicants_name?.toLowerCase().includes(search) ||
	    a.email?.toLowerCase().includes(search) ||
	    a.mobile_no?.toLowerCase().includes(search) ||
	    a.applicant_location?.toLowerCase().includes(search)
	  );
	});


  const jobApplicants = applicants || [];

  const columns = [
  	{ title: 'Recieved On', dataIndex: 'created_on', key: 'date',sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),render: (text) => text ? dayjs(text).format('DD MMM YYYY') : 'N/A', },
    { title: 'Name', dataIndex: 'applicants_name', key: 'name',sorter: (a, b) => (a.applicants_name || '').localeCompare(b.applicants_name || ''), },
    { title: 'Mobile', dataIndex: 'mobile_no', key: 'phone',sorter: (a, b) => (a.mobile_no || '').localeCompare(b.mobile_no || ''), },
    { title: 'Email', dataIndex: 'email', key: 'email',sorter: (a, b) => (a.email || '').localeCompare(b.email || ''), },
    { title: 'Location', dataIndex: 'applicant_location', key: 'location', ...getLocationFilter('applicant_location') },
    {
      title: 'Resume',
      dataIndex: 'support_document',
      key: 'resume',
      render: (text) =>
        text?.includes('null') || !text ? 'N/A' : (
          <a href={text} target="_blank" rel="noopener noreferrer">View</a>
        ),
    },
  ];

  return (
    <Styled.MainContainer>
      <Styled.Header>
        <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/> </a></Tooltip>
  		  <div>
  		    Applicants for <b style={{ marginLeft: 1 }}>{jobTitle}</b>
  		  </div>
        <span></span>
      </Styled.Header>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Input
          placeholder="Search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 250 }}
          allowClear
        />
      </div>
      
      <div className="recordCount">{filteredApplicants.length} records</div>
      <Table
        className="drill-down-table table_container"
        dataSource={filteredApplicants.map((a, i) => ({ ...a, key: i }))}
        columns={columns}
		    pagination={{ pageSize: 20, showSizeChanger: false }}      
      />
    </Styled.MainContainer>
  );
};

export default ApplicantList;
